import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Weblog.css";
import { Button } from "primereact/button";
import { TabView, TabPanel } from 'primereact/tabview';
import { apiClient } from "../apiClient";
import colors from '../colors';






const DownloadHTML = (props) => {

        const token = JSON.parse(localStorage.getItem("userToken"));
        const config = {headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },};
        const [fetchedArticle, setFetchedArticle] = useState();
        const [userWebsite,setUserWebsite] = useState();
        const navigate = useNavigate();
        

       
        //fetch article data:
        useEffect(() => {

            async function fetchSingleArticle() {
            try {
                const result = await apiClient.get(
                `${process.env.REACT_APP_BACK}/articles/${props.article_id}`,
                config
                );
                if (result.status === 200) {
                setFetchedArticle(result.data);
                }
            } catch (error) {
                console.error(error);
                
            }
            }
            fetchSingleArticle();
        }, []);


        //fetch user website:
        useEffect( () =>
        {
            async function fetchUserWebsite()
            {
                try {
                    const result = await apiClient.get(
                    `${process.env.REACT_APP_BACK}/users/userwebsite/${fetchedArticle?.creator._id}`,
                    config
                    );
                    if (result.status === 200) {
                        setUserWebsite(result.data.website);
                        console.log("website",result.data.website);

                    }
                } catch (error) {
                    console.error(error);
                    
                }

            } 

            if(fetchedArticle)
            fetchUserWebsite();

        }
            
        ,[fetchedArticle]);
        



        //format html code of content for better displaying:
        const formatHtmlContent = (htmlString) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, "text/html");
        
            const traverseNodes = (node, level = 0) => {
            if (node.nodeType === Node.TEXT_NODE) {
                if (node.textContent.trim() === "") return null; // Ignore empty text nodes
                return (
                <div
                    key={Math.random()}
                    style={{
                    paddingLeft: `${level * 20}px`,
                    textAlign: "left",
                    }}
                >
                    {node.textContent.trim()}
                </div>
                );
            }
        
            if (node.nodeType === Node.ELEMENT_NODE) {
                const children = Array.from(node.childNodes)
                .map((child) => traverseNodes(child, level + 1))
                .filter(Boolean);
        
                return (
                <div
                    key={Math.random()}
                    style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    paddingLeft: `${level * 20}px`,
                    margin: "4px 0",
                    }}
                >
                    <div
                    style={{
                        textAlign: "left",
                        width: "100%",
                        color: colors.primary,
                    }}
                    >
                    {`<${node.tagName.toLowerCase()} ${
                        node.attributes.length > 0
                        ? Array.from(node.attributes)
                            .map((attr) => `${attr.name}="${attr.value}"`)
                            .join(" ")
                        : ""
                    }>`}
                    </div>
                    {children}
                    <div
                    style={{
                        textAlign: "left",
                        width: "100%",
                        color: colors.primary,
                    }}
                    >
                    {`</${node.tagName.toLowerCase()}>`}
                    </div>
                </div>
                );
            }
        
            return null;
            };
        
            const children = Array.from(doc.body.childNodes)
            .map((node) => traverseNodes(node))
            .filter(Boolean);
        
            return children;
        };


        const formattedContent = formatHtmlContent("<h1>"+fetchedArticle?.title+"</h1>"+fetchedArticle?.content);

        const formatHtmlMeta = () => {
            const fetchedMeta = fetchedArticle;
          
            const metaContent = `
            <head>
              <title>${fetchedMeta?.title || "Untitled"}</title>
              <meta name="description" content="${fetchedMeta?.metaDescription || "No description available"}" />
              <meta name="robots" content="index, follow" />
              <meta name="author" content="${fetchedMeta?.creator?.name || "Unknown"} ${fetchedMeta?.creator?.familyName || ""}" />
              <link rel="canonical" href="${process.env.REACT_APP_SITE_URL}/weblog/${fetchedMeta?._id}" />
              <meta property="og:title" content="${fetchedMeta?.title || "Untitled"}" />
              <meta property="og:description" content="${fetchedMeta?.metaDescription || "No description available"}" />
              <meta property="og:image" content="${userWebsite}/articles/${fetchedMeta?.indexedImage || "default.jpg"}" />
              <meta property="og:url" content="${userWebsite}/weblog/${fetchedMeta?._id}" />
              <meta property="og:type" content="article" />
              <meta property="article:published_time" content="${fetchedMeta?.createdDate || "2024-07-28"}" />
              <meta property="article:author" content="${fetchedMeta?.creator?.name || "Unknown"} ${fetchedMeta?.creator?.familyName || ""}" />
              <meta name="twitter:card" content="summary_large_image" />
            </head>
            `;
          
            return (
              <div>
                
                <pre>
                  {metaContent}
                </pre>
              </div>
            );
          };
          

        const formatHtmlCss = () =>
        {

        }


        //download content:
        const handleDownloadContent = () => {
            
            // Wrap the content in a single root element
            const parser = new DOMParser();
            const serializer = new XMLSerializer();
            const doc = parser.parseFromString(`<article  style="text-align: right; direction:rtl;">
                ${"<h1>"+fetchedArticle?.title+"</h1>"+fetchedArticle?.content}</article>`, "text/html");
        
            // Update all image tags to have absolute URLs if they are not
            const images = doc.querySelectorAll("img");
            images.forEach((img) => {
              if (!img.src.startsWith("http")) {
                img.src = window.location.origin + img.getAttribute("src");
              }
            });

             // Serialize the document as pretty-printed XML
            const prettyXml = serializer.serializeToString(doc);

            // Create and download the file
            const blob = new Blob([prettyXml], { type: "application/xml" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "article_"+fetchedArticle?._id+"_content"+".xml";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            };

            
            //download meta:
            const handleDownloadMeta = () => {
                const fetchedMeta = fetchedArticle;
              
                // Generate the XML content for the <head> tag
                const metaXml = `
                  <head>
                    <title>${fetchedMeta?.title || "Untitled"}</title>
                    <meta name="description" content="${fetchedMeta?.metaDescription || "No description available"}" />
                    <meta name="robots" content="index, follow" />
                    <meta name="author" content="${fetchedMeta?.creator?.name + " " + fetchedMeta?.creator?.familyName|| "Unknown"}" />
                    <link rel="canonical" href="${process.env.REACT_APP_SITE_URL}/weblog/${fetchedMeta?._id}" />
                    <meta property="og:title" content="${fetchedMeta?.title || "Untitled"}" />
                    <meta property="og:description" content="${fetchedMeta?.metaDescription || "No description available"}" />
                    <meta property="og:image" content="${userWebsite}/articles/${fetchedMeta?.indexedImage || "default.jpg"}" />
                    <meta property="og:url" content="${userWebsite}/articles/${fetchedMeta?._id}" />
                    <meta property="og:type" content="article" />
                    <meta property="article:published_time" content="${fetchedMeta?.createdDate || "2024-07-28"}" />
                    <meta property="article:author" content="${fetchedMeta?.creator?.name + " " + fetchedMeta?.creator?.familyName || "Unknown"}" />
                    <meta name="twitter:card" content="summary_large_image" />
                  </head>
                `.trim();
              
                // Create and download the file
                const blob = new Blob([metaXml], { type: "application/xml" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `article_${fetchedMeta?._id}_meta.xml`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              };
              
              
    
        


        return (
            
            <div id="download-html-dialog">
            
            <h2 style={{ marginBottom: "50px", direction: "rtl" }}>دانلود کد html</h2>

            <span style={{direction:'rtl',display:'table',margin:'auto'}}>
                <Button onClick={handleDownloadMeta} style={{ marginBottom: "20px",marginLeft:'20px' }}>
                    دانلود فایل متا
                </Button>
                <Button onClick={handleDownloadContent} style={{ marginBottom: "20px",marginLeft:'20px' }}>
                    دانلود فایل محتوا
                </Button>
               
                
                
            </span>

          


            <TabView>
                <TabPanel header="کد متا" >
                    <div className="html-content">{formatHtmlMeta()}</div>
                </TabPanel>
                <TabPanel header="کد محتوا">
                    <div className="html-content">{formattedContent}</div>
                </TabPanel>
               
            </TabView>


            </div>
        );
};

export default DownloadHTML;
